<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <MeasureListWidget :auditId="auditId" list-config-key="auditActionlist"/>
    </v-layout>
  </v-container>
</template>

<script>
import MeasureListWidget from "@/components/widgets/MeasureListWidget.vue";

import AuditIdBaseMixin from "@/components/mixins/AuditIdBaseMixin";

export default {
  components: {
    MeasureListWidget
  },
  mixins: [AuditIdBaseMixin],
  data: () => ({}),
  computed: {},
  methods: {}
};
</script>
